(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  class FAQSection {
    constructor(container) {
      this.container = container;
      this.faqItems = container.querySelectorAll('.faq-item');
      this.showMoreBtn = container.querySelector('.faq-show-more-btn');
      this.paginationContainer = container.querySelector('.faq-pagination');

      // Get configuration from data attributes
      this.initialCount = parseInt(container.querySelector('.faq-items-container').dataset.initialCount) || 3;

      // State management
      this.isExpanded = false;
      this.currentlyOpenItem = null;

      // Button text
      this.showMoreText = this.showMoreBtn?.dataset.showText || 'Show more';
      this.showLessText = this.showMoreBtn?.dataset.showLessText || 'Show less';

      this.init();
    }

    init() {
      this.setupEventListeners();
      this.toggleProductGroups(); // Hide product groups with no visible FAQs on load
    }

    setupEventListeners() {
      // Show more/less button
      if (this.showMoreBtn) {
        this.showMoreBtn.addEventListener('click', () => this.toggleShowMore());
      }

      // Product accordion toggle listeners
      const productAccordions = this.container.querySelectorAll('.faq-product-accordion');
      productAccordions.forEach((details) => {
        const button = details.querySelector('.faq-product-toggle-button');

        // Add click handler to the button
        if (button) {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Toggle the accordion manually
            if (details.hasAttribute('open')) {
              details.removeAttribute('open');
            } else {
              details.setAttribute('open', '');
            }
          });
        }
      });

      // Accordion toggle listeners for individual FAQs
      this.faqItems.forEach((item) => {
        const summary = item.querySelector('.faq-summary');
        const details = item.querySelector('.faq-details');

        if (summary && details) {
          summary.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleAccordion(details);
          });
        }
      });
    }

    toggleShowMore() {
      if (this.isExpanded) {
        // Show less - hide items beyond initial count
        const itemsToHide = Array.from(this.faqItems).slice(this.initialCount);
        itemsToHide.forEach((item) => {
          item.classList.add('faq-item--hidden');
          // Close any open items that will be hidden
          const details = item.querySelector('.faq-details');
          if (details && details.hasAttribute('open')) {
            details.removeAttribute('open');
          }
        });

        this.isExpanded = false;
        this.showMoreBtn.textContent = this.showMoreText;
        if (this.paginationContainer) {
          this.paginationContainer.style.display = 'flex';
        }
      } else {
        // Show more - reveal all hidden items
        const hiddenItems = this.container.querySelectorAll('.faq-item--hidden');
        hiddenItems.forEach((item) => {
          item.classList.remove('faq-item--hidden');
        });

        this.isExpanded = true;
        this.showMoreBtn.textContent = this.showLessText;
        if (this.paginationContainer) {
          this.paginationContainer.style.display = 'none';
        }
      }

      // Hide/show product groups based on visible FAQs
      this.toggleProductGroups();
    }

    toggleProductGroups() {
      const productGroups = this.container.querySelectorAll('.faq-product-group');
      productGroups.forEach((group) => {
        const productAccordion = group.querySelector('.faq-product-accordion');

        // Check if this is a product accordion (grouped mode)
        if (productAccordion) {
          // In product accordion mode, don't auto-hide groups
          // The accordion handles visibility
          return;
        }

        // Original logic for non-accordion product groups
        const faqItems = group.querySelectorAll('.faq-item');
        const visibleItems = group.querySelectorAll('.faq-item:not(.faq-item--hidden)');

        if (visibleItems.length === 0) {
          // All FAQ items in this group are hidden, hide the entire group
          group.classList.add('faq-product-group--hidden');
        } else {
          // At least one FAQ item is visible, show the group
          group.classList.remove('faq-product-group--hidden');
        }
      });
    }

    toggleAccordion(details) {
      const isCurrentlyOpen = details.hasAttribute('open');

      // Close currently open item if it's different
      if (this.currentlyOpenItem && this.currentlyOpenItem !== details) {
        this.currentlyOpenItem.removeAttribute('open');
      }

      if (isCurrentlyOpen) {
        details.removeAttribute('open');
        this.currentlyOpenItem = null;
      } else {
        details.setAttribute('open', '');
        this.currentlyOpenItem = details;
      }
    }
  }

  // Initialize FAQ sections when DOM is loaded
  document.addEventListener('DOMContentLoaded', function () {
    const faqSections = document.querySelectorAll('.faq-section');
    faqSections.forEach((section) => {
      new FAQSection(section);
    });
  });

  // Re-initialize on theme editor updates
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.faq-section')) {
      new FAQSection(event.target.querySelector('.faq-section'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-pr"] && !Shopify.designMode) return;
  try {
    
  function initFeaturedPrSlider() {
    // Wait for jQuery and Slick to be available
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(initFeaturedPrSlider, 100);
      return;
    }

    const featuredPrSliders = document.querySelectorAll('.featured-pr__list--desktop-slider');

    featuredPrSliders.forEach(function (slider) {
      const $slider = jQuery(slider);
      const slidesToShow = parseInt(slider.dataset.slidesToShow);
      const autoplayEnabled = slider.dataset.autoplayEnabled === 'true';
      const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed);

      // Count total slides
      const totalSlides = slider.querySelectorAll('.featured-pr__item').length;

      // Only show dots if there are more slides than what's visible
      const showDots = totalSlides > slidesToShow;
      const showArrows = totalSlides > slidesToShow;

      // Find controls container
      const controlsContainer = slider.closest('.featured-pr__container').querySelector('.featured-pr__slick-controls');

      // Hide controls container if no navigation needed
      if (!showDots && !showArrows) {
        if (controlsContainer) {
          controlsContainer.style.display = 'none';
        }
      } else {
        if (controlsContainer) {
          controlsContainer.style.display = '';
        }
      }

      $slider.slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        infinite: totalSlides > slidesToShow,
        autoplay: autoplayEnabled && totalSlides > slidesToShow,
        autoplaySpeed: autoplaySpeed,
        dots: showDots,
        arrows: showArrows,
        appendArrows: jQuery('.featured-pr__slick-controls'),
        appendDots: jQuery('.featured-pr__slick-controls'),
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: Math.max(1, Math.floor(slidesToShow / 2)),
              slidesToScroll: 1,
              dots: totalSlides > Math.max(1, Math.floor(slidesToShow / 2)),
              arrows: totalSlides > Math.max(1, Math.floor(slidesToShow / 2)),
              infinite: totalSlides > Math.max(1, Math.floor(slidesToShow / 2)),
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: Math.max(1, Math.floor(slidesToShow / 3)),
              slidesToScroll: 1,
              dots: totalSlides > Math.max(1, Math.floor(slidesToShow / 3)),
              arrows: false,
              infinite: totalSlides > Math.max(1, Math.floor(slidesToShow / 3)),
            },
          },
        ],
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedPrSlider);
  } else {
    initFeaturedPrSlider();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  class BlogNavigation {
    constructor() {
      this.blogNavToggle = document.querySelector('.blog-nav-toggle');
      this.articleFilterTags = document.querySelector('.article-filter__tags');
      this.articleFilterRoot = document.querySelector('.article-filter');
      this.init();
    }

    init() {
      if (this.blogNavToggle && this.articleFilterTags) {
        this.blogNavToggle.addEventListener('click', () => {
          this.blogNavToggle.classList.toggle('active');
          this.articleFilterTags.classList.toggle('active');
        });
      }

      this.updateTagCounts();
    }

    updateTagCounts() {
      if (!this.articleFilterRoot) return;
      const sfToken = this.articleFilterRoot.getAttribute('data-sf-token');
      const blogHandle = this.articleFilterRoot.getAttribute('data-blog-handle');
      const apiVersion = this.articleFilterRoot.getAttribute('data-api-version') || '2024-07';
      if (!sfToken || !blogHandle) return;
      const loader = this.articleFilterRoot.querySelector('.article-filter__loader');
      const showLoader = () => { if (loader) loader.hidden = false; };
      const hideLoader = () => { if (loader) loader.hidden = true; };
      showLoader();

      const endpoint = `/api/${apiVersion}/graphql.json`;
      const query = `query BlogTags($handle: String!, $pageSize: Int!, $cursor: String) {\n  blog(handle: $handle) {\n    articles(first: $pageSize, after: $cursor) {\n      edges {\n        cursor\n        node {\n          tags\n        }\n      }\n      pageInfo {\n        hasNextPage\n      }\n    }\n  }\n}`;

      const aggregateCountsStorefront = async () => {
        const counts = Object.create(null);
        let cursor = null;
        const pageSize = 100;
        let safety = 0;
        while (safety < 100) {
          safety++;
          const variables = { handle: blogHandle, pageSize, cursor };
          const res = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Shopify-Storefront-Access-Token': sfToken
            },
            body: JSON.stringify({ query, variables })
          });
          if (!res.ok) break;
          const json = await res.json();
          const data = json && json.data && json.data.blog && json.data.blog.articles;
          if (!data) break;
          for (const edge of data.edges || []) {
            const tags = (edge.node && edge.node.tags) || [];
            for (const tag of tags) {
              counts[tag] = (counts[tag] || 0) + 1;
            }
            cursor = edge.cursor;
          }
          if (!data.pageInfo || !data.pageInfo.hasNextPage) break;
        }
        return counts;
      };

      const aggregateCountsJson = async () => {
        const counts = Object.create(null);
        let page = 1;
        const limit = 250;
        let safety = 0;
        while (safety < 100) {
          safety++;
          const url = `/blogs/${encodeURIComponent(blogHandle)}/articles.json?limit=${limit}&page=${page}`;
          const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
          if (!res.ok) break;
          const json = await res.json();
          const articles = Array.isArray(json?.articles) ? json.articles : (Array.isArray(json) ? json : []);
          if (!articles || articles.length === 0) break;
          for (const art of articles) {
            let tags = art.tags;
            if (Array.isArray(tags)) {
              // ok
            } else if (typeof tags === 'string') {
              tags = tags.split(',').map((t) => t.trim()).filter(Boolean);
            } else {
              tags = [];
            }
            for (const t of tags) {
              counts[t] = (counts[t] || 0) + 1;
            }
          }
          page++;
        }
        return counts;
      };

      const applyCountsToChips = (counts) => {
        if (!counts || Object.keys(counts).length === 0) return false;
        const countsNorm = Object.create(null);
        for (const key of Object.keys(counts)) {
          countsNorm[key.trim().toLowerCase()] = counts[key];
        }
        const chips = this.articleFilterTags.querySelectorAll('.tag-chip');
        let updated = false;
        chips.forEach((chip) => {
          const labelEl = chip.querySelector('.tag-chip__label');
          const countEl = chip.querySelector('.tag-chip__count');
          const chipLoader = chip.querySelector('.tag-chip__loader');
          if (!labelEl || !countEl) return;
          const label = labelEl.textContent.trim();
          const labelNorm = label.toLowerCase();
          if (labelNorm === 'all articles') return;
          const value = countsNorm[labelNorm];
          if (typeof value === 'number') {
            countEl.textContent = `${value} results`;
            // hide loader and show count
            if (chipLoader) chipLoader.setAttribute('hidden', 'true');
            if (countEl.classList) countEl.classList.remove('tag-chip__count--hidden');
            updated = true;
          }
        });
        return updated;
      };

      const fetchLiquidCounts = async () => {
        // e.g., /blogs/news?view=counts
        const res = await fetch(`${window.location.origin}/blogs/${encodeURIComponent(blogHandle)}?view=counts`, {
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) return null;
        const json = await res.json();
        return json && json.tags ? json.tags : null;
      };

      // Prefer liquid JSON (consistent with what theme sees), then Storefront, then JSON fallback
      // When starting, if loaders exist (tagged page), ensure loader visible and count hidden via class
      if (this.articleFilterRoot.querySelectorAll('.tag-chip__loader').length) {
        this.articleFilterRoot.querySelectorAll('.tag-chip').forEach((chip) => {
          const countEl = chip.querySelector('.tag-chip__count');
          const chipLoader = chip.querySelector('.tag-chip__loader');
          if (countEl && chipLoader) {
            if (!countEl.classList.contains('tag-chip__count--hidden')) {
              countEl.classList.add('tag-chip__count--hidden');
            }
            chipLoader.removeAttribute('hidden');
          }
        });
      }
      fetchLiquidCounts()
        .then((counts) => {
          if (!applyCountsToChips(counts)) {
            return aggregateCountsStorefront()
              .then((c) => { if (!applyCountsToChips(c)) return aggregateCountsJson().then(applyCountsToChips); })
              .catch(() => aggregateCountsJson().then(applyCountsToChips).catch(() => {}));
          }
        })
        .catch(() => {
          aggregateCountsStorefront()
            .then((c) => { if (!applyCountsToChips(c)) return aggregateCountsJson().then(applyCountsToChips); })
            .catch(() => aggregateCountsJson().then(applyCountsToChips).catch(() => {}));
        })
        .finally(() => {
          hideLoader();
        });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    new BlogNavigation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-support"] && !Shopify.designMode) return;
  try {
    
  class CustomerSupportSection {
    constructor(container) {
      this.container = container;
      this.navItems = container.querySelectorAll('.customer-support-nav-item');
      this.mobileToggle = container.querySelector('.customer-support-nav-toggle');
      this.navList = container.querySelector('.customer-support-nav-list');
      this.hideMobileDropdown = container.querySelector('.hide-mobile-dropdown') !== null;

      this.init();
    }

    init() {
      this.setupSmoothScrolling();
      this.setupMobileDropdown();
      this.setupActiveNavigation();
      this.initializeMobileView();
      this.setupResizeHandler();
    }

    setupSmoothScrolling() {
      this.navItems.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            // Check if we're on mobile
            if (window.innerWidth <= 749) {
              if (this.hideMobileDropdown) {
                // If dropdown is hidden, use smooth scroll (desktop-like behavior)
                targetElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              } else {
                // Normal mobile behavior - hide all sections and show selected one
                const allSections = document.querySelectorAll('.customer-support-content-section');
                allSections.forEach((section) => {
                  section.style.display = 'none';
                });

                // Show only the selected section
                targetElement.style.display = 'block';

                // Update toggle button text and active state
                const linkText = link.textContent.trim();
                if (this.mobileToggle) {
                  this.mobileToggle.querySelector('span').textContent = linkText;
                }

                // Update active navigation item
                this.navItems.forEach((item) => {
                  item.classList.remove('active');
                });
                link.classList.add('active');
              }
            } else {
              // Desktop behavior - smooth scroll
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }

            // Close mobile menu after navigation
            if (this.navList && this.navList.classList.contains('active')) {
              this.navList.classList.remove('active');
              this.mobileToggle.classList.remove('active');
              this.mobileToggle.setAttribute('aria-expanded', 'false');
            }
          }
        });
      });
    }

    setupMobileDropdown() {
      // Don't setup mobile dropdown if it should be hidden
      if (this.hideMobileDropdown) {
        return;
      }

      if (this.mobileToggle && this.navList) {
        this.mobileToggle.addEventListener('click', () => {
          const isExpanded = this.mobileToggle.getAttribute('aria-expanded') === 'true';

          this.navList.classList.toggle('active');
          this.mobileToggle.classList.toggle('active');
          this.mobileToggle.setAttribute('aria-expanded', !isExpanded);
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (!this.mobileToggle.contains(e.target) && !this.navList.contains(e.target)) {
            this.navList.classList.remove('active');
            this.mobileToggle.classList.remove('active');
            this.mobileToggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

    initializeMobileView() {
      // Initialize mobile view
      if (window.innerWidth <= 749) {
        const allSections = document.querySelectorAll('.customer-support-content-section');

        if (this.hideMobileDropdown) {
          // If dropdown is hidden, show all sections (desktop-like behavior on mobile)
          allSections.forEach((section) => {
            section.style.display = 'block';
          });
        } else {
          // Normal mobile behavior - show first section by default
          allSections.forEach((section) => {
            section.style.display = 'none';
          });

          // Show first section
          if (allSections.length > 0) {
            allSections[0].style.display = 'block';
          }

          // Setup mobile navigation
          if (this.navItems.length > 0) {
            this.navItems.forEach((item) => {
              item.classList.remove('active');
            });
            this.navItems[0].classList.add('active');

            // Update toggle button text
            if (this.mobileToggle) {
              const firstItemText = this.navItems[0].textContent.trim();
              this.mobileToggle.querySelector('span').textContent = firstItemText;
            }
          }
        }
      }
    }

    setupResizeHandler() {
      // Handle window resize to switch between mobile and desktop behavior
      window.addEventListener('resize', () => {
        const allSections = document.querySelectorAll('.customer-support-content-section');

        if (window.innerWidth <= 749) {
          if (this.hideMobileDropdown) {
            // If dropdown is hidden, show all sections (desktop-like behavior on mobile)
            allSections.forEach((section) => {
              section.style.display = 'block';
            });
          } else {
            // Normal mobile view - hide all sections except first
            allSections.forEach((section, index) => {
              section.style.display = index === 0 ? 'block' : 'none';
            });

            // Setup mobile navigation
            if (this.navItems.length > 0) {
              this.navItems.forEach((item) => {
                item.classList.remove('active');
              });
              this.navItems[0].classList.add('active');

              // Update toggle button text
              if (this.mobileToggle) {
                const firstItemText = this.navItems[0].textContent.trim();
                this.mobileToggle.querySelector('span').textContent = firstItemText;
              }
            }
          }
        } else {
          // Desktop view - show all sections
          allSections.forEach((section) => {
            section.style.display = 'block';
          });
        }
      });
    }

    setupActiveNavigation() {
      // Update active navigation item based on scroll position
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const targetId = entry.target.id;
              this.updateActiveNavItem(targetId);
            }
          });
        },
        {
          rootMargin: '-20% 0px -70% 0px',
        }
      );

      // Observe all sections
      const sections = document.querySelectorAll('.customer-support-content-section');
      sections.forEach((section) => {
        observer.observe(section);
      });
    }

    updateActiveNavItem(activeId) {
      this.navItems.forEach((item) => {
        item.classList.remove('active');
        if (item.getAttribute('href') === `#${activeId}`) {
          item.classList.add('active');

          // Update mobile toggle button text to match active item (only if dropdown is not hidden)
          if (this.mobileToggle && window.innerWidth <= 749 && !this.hideMobileDropdown) {
            const linkText = item.textContent.trim();
            this.mobileToggle.querySelector('span').textContent = linkText;
          }
        }
      });
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', function () {
    // Add a small delay to ensure all sections are loaded
    setTimeout(() => {
      const customerSupportSections = document.querySelectorAll('.customer-support-section');
      customerSupportSections.forEach((section) => {
        new CustomerSupportSection(section);
      });
    }, 100);
  });

  // Re-initialize on theme editor updates
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.customer-support-section')) {
      setTimeout(() => {
        new CustomerSupportSection(event.target.querySelector('.customer-support-section'));
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-term-condition"] && !Shopify.designMode) return;
  try {
    
  class TermConditionSection {
    constructor(container) {
      this.container = container;
      this.navItems = container.querySelectorAll('.term-nav-item');
      this.mobileToggle = container.querySelector('.term-nav-toggle');
      this.navList = container.querySelector('.term-nav-list');

      this.init();
    }

    init() {
      this.setupSmoothScrolling();
      this.setupMobileDropdown();
      this.setupActiveNavigation();
      this.initializeMobileView();
      this.setupResizeHandler();
    }

    setupSmoothScrolling() {
      this.navItems.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            // Check if we're on mobile
            if (window.innerWidth <= 749) {
              // Hide all content sections
              const allSections = this.container.querySelectorAll('.term-content-section');
              allSections.forEach((section) => {
                section.style.display = 'none';
              });

              // Show only the selected section
              targetElement.style.display = 'block';

              // Update toggle button text and active state
              const linkText = link.textContent.trim();
              this.mobileToggle.querySelector('span').textContent = linkText;

              // Update active navigation item
              this.navItems.forEach((item) => {
                item.classList.remove('active');
              });
              link.classList.add('active');
            } else {
              // Desktop behavior - smooth scroll
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }

            // Close mobile menu after navigation
            if (this.navList && this.navList.classList.contains('active')) {
              this.navList.classList.remove('active');
              this.mobileToggle.classList.remove('active');
              this.mobileToggle.setAttribute('aria-expanded', 'false');
            }
          }
        });
      });
    }

    setupMobileDropdown() {
      if (this.mobileToggle && this.navList) {
        this.mobileToggle.addEventListener('click', () => {
          const isExpanded = this.mobileToggle.getAttribute('aria-expanded') === 'true';

          this.navList.classList.toggle('active');
          this.mobileToggle.classList.toggle('active');
          this.mobileToggle.setAttribute('aria-expanded', !isExpanded);
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (!this.mobileToggle.contains(e.target) && !this.navList.contains(e.target)) {
            this.navList.classList.remove('active');
            this.mobileToggle.classList.remove('active');
            this.mobileToggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

    initializeMobileView() {
      // Initialize mobile view - show first section by default
      if (window.innerWidth <= 749) {
        const allSections = this.container.querySelectorAll('.term-content-section');
        allSections.forEach((section) => {
          section.style.display = 'none';
        });

        // Show first section
        if (allSections.length > 0) {
          allSections[0].style.display = 'block';
        }

        // Set first navigation item as active and update toggle button
        if (this.navItems.length > 0) {
          this.navItems.forEach((item) => {
            item.classList.remove('active');
          });
          this.navItems[0].classList.add('active');

          // Update toggle button text
          const firstItemText = this.navItems[0].textContent.trim();
          this.mobileToggle.querySelector('span').textContent = firstItemText;
        }
      }
    }

    setupResizeHandler() {
      // Handle window resize to switch between mobile and desktop behavior
      window.addEventListener('resize', () => {
        const allSections = this.container.querySelectorAll('.term-content-section');

        if (window.innerWidth <= 749) {
          // Mobile view - hide all sections except first
          allSections.forEach((section, index) => {
            section.style.display = index === 0 ? 'block' : 'none';
          });

          // Set first navigation item as active and update toggle button
          if (this.navItems.length > 0) {
            this.navItems.forEach((item) => {
              item.classList.remove('active');
            });
            this.navItems[0].classList.add('active');

            // Update toggle button text
            const firstItemText = this.navItems[0].textContent.trim();
            this.mobileToggle.querySelector('span').textContent = firstItemText;
          }
        } else {
          // Desktop view - show all sections
          allSections.forEach((section) => {
            section.style.display = 'block';
          });
        }
      });
    }

    setupActiveNavigation() {
      // Update active navigation item based on scroll position
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const targetId = entry.target.id;
              this.updateActiveNavItem(targetId);
            }
          });
        },
        {
          rootMargin: '-20% 0px -70% 0px',
        }
      );

      // Observe all sections
      const sections = this.container.querySelectorAll('.term-content-section');
      sections.forEach((section) => {
        observer.observe(section);
      });
    }

    updateActiveNavItem(activeId) {
      this.navItems.forEach((item) => {
        item.classList.remove('active');
        if (item.getAttribute('href') === `#${activeId}`) {
          item.classList.add('active');

          // Update mobile toggle button text to match active item
          if (this.mobileToggle && window.innerWidth <= 749) {
            const linkText = item.textContent.trim();
            this.mobileToggle.querySelector('span').textContent = linkText;
          }
        }
      });
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', function () {
    const termSections = document.querySelectorAll('.term-condition-section');
    termSections.forEach((section) => {
      new TermConditionSection(section);
    });
  });

  // Re-initialize on theme editor updates
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.term-condition-section')) {
      new TermConditionSection(event.target.querySelector('.term-condition-section'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const testimonialSliders = document.querySelectorAll('.testimonials__list.testimonials__slider');

    testimonialSliders.forEach(function (slider) {
      const $slider = $(slider);
      const slidesToShowDesktop = parseInt(slider.dataset.slidesToShowDesktop);
      const slidesToShowMobile = parseInt(slider.dataset.slidesToShowMobile);
      const autoplayEnabled = slider.dataset.autoplayEnabled === 'true';
      const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed);

      $slider.slick({
        slidesToShow: slidesToShowDesktop,
        slidesToScroll: 1,
        infinite: true,
        autoplay: autoplayEnabled,
        autoplaySpeed: autoplaySpeed,
        dots: true,
        arrows: true,
        appendArrows: $('.testimonials__slick-controls'),
        appendDots: $('.testimonials__slick-controls'),
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: slidesToShowMobile,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: slidesToShowMobile,
              slidesToScroll: 1,
              infinite: true,
              variableWidth: true,
              dots: true,
              arrows: false,
            },
          },
        ],
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
